import type { HTMLAttributes } from 'react';
import styled from 'styled-components';
import type { Size } from 'types/size';
import BodyStyling from '../styles/body';
import type { fontSizeTypes, IText } from '../types';
import Text from './Text';

const StyledText = styled(Text)<{ $strong: IBody['strong'] }>`
    ${BodyStyling}
    
    margin-bottom: 0;
`;

type BodyTypes = 'p' | 'span' | 'div' | 'a' | 'label' | 'li';

export type BodySize = Extract<Size, 'S' | 'M' | 'L'>;
export interface IBody extends Omit<IText, 'size'>, HTMLAttributes<HTMLSpanElement> {
    as?: BodyTypes;
    size?: BodySize;
    strong?: boolean;
    forwardedAs?: BodyTypes;
}

const BodySizeMap: Record<BodySize, fontSizeTypes> = {
    S: 12,
    M: 14,
    L: 16
};

export default function Body(props: IBody): JSX.Element {
    const { as = 'p', size = 'M', strong = false, children, ...restProps } = props;

    return (
        <StyledText forwardedAs={as} size={BodySizeMap[size]} $strong={strong} {...restProps}>
            {children}
        </StyledText>
    );
}
